module.exports = __webpack_public_path__ + "assets/images/slope-aging/mobile.svg?v=ce5fea08";